module.exports = __webpack_public_path__ + "img/high.d9f74cba.webp";